import React, { useState } from "react";
import { Rnd } from "react-rnd";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import MinimizeIcon from "@mui/icons-material/Minimize";

const windowHeaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: "#1976d2",
  color: "#fff",
  padding: "10px 18px",
  fontWeight: 700,
  cursor: "move"
};

export default function DesktopWindow({
  id,
  title,
  children,
  position,
  size,
  zIndex,
  onClose,
  onFocus,
  onMinimize,
  minimized = false,
  minWidth = 350,
  minHeight = 200,
  allowFullscreen = true,
  defaultFullscreen = false
}) {
  const [fullscreen, setFullscreen] = useState(defaultFullscreen);

  // Calcul de la taille de l'écran parent pour le plein écran
  const getParentSize = () => {
    const parent = document.body;
    return {
      width: parent.clientWidth,
      height: parent.clientHeight,
      x: 0,
      y: 0
    };
  };

  // Helper: check if event target is inside a MUI Dialog
  function isEventInMuiDialog(e) {
    return e.target.closest('.MuiDialog-root');
  }

  if (minimized) return null;

  // Patch: Prevent drag/focus when a Dialog is open and mouse is inside Dialog
  const guardedOnFocus = (e) => {
    if (isEventInMuiDialog(e)) {
      e.stopPropagation();
      return;
    }
    if (onFocus) onFocus(e);
  };

  return (
    <Rnd
      default={fullscreen ? getParentSize() : { x: position.x, y: position.y, width: size.width, height: size.height }}
      size={fullscreen ? { width: getParentSize().width, height: getParentSize().height } : undefined}
      position={fullscreen ? { x: 0, y: 0 } : undefined}
      minWidth={minWidth}
      minHeight={minHeight}
      bounds="parent"
      style={{ zIndex, boxShadow: "0 8px 32px rgba(0,0,0,0.25)", borderRadius: 8, overflow: "hidden", position: "absolute", background: "#fff" }}
      onDragStart={guardedOnFocus}
      onMouseDown={guardedOnFocus}
      disableDragging={fullscreen}
      enableResizing={!fullscreen}
      dragHandleClassName="desktop-window-header"
    >
      <div className="desktop-window-header" style={windowHeaderStyle} onMouseDown={guardedOnFocus}>
        <span>{title}</span>
        <span>
          {allowFullscreen && (
            <button
              style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer", marginRight: 8 }}
              onClick={() => setFullscreen(f => !f)}
              onTouchStart={() => setFullscreen(f => !f)}
              title={fullscreen ? "Quitter le plein écran" : "Plein écran"}
            >
              {fullscreen ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
            </button>
          )}
          {onMinimize && (
            <button
              style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer", marginRight: 8 }}
              onClick={onMinimize}
              onTouchStart={onMinimize}
              title="Minimiser"
            >
              <MinimizeIcon fontSize="small" />
            </button>
          )}
          <button
            style={{ background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer" }}
            onClick={onClose}
            onTouchStart={onClose}
            title="Fermer"
          >
            ×
          </button>
        </span>
      </div>
      <div style={{ padding: 0, height: 'calc(100% - 48px)', minHeight: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
        {children}
      </div>
    </Rnd>
  );
}
